import script from "./BaseMobileMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseMobileMenu.vue?vue&type=script&lang=ts&setup=true"

import "./BaseMobileMenu.vue?vue&type=style&index=0&id=84b48b2e&scoped=true&lang=css"
/* custom blocks */
import block0 from "./BaseMobileMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84b48b2e"]])

export default __exports__